import { gql } from 'react-apollo';

export const SEND_REQUEST = gql`
  mutation SendRequest($firstName: String!, $username: String!, $companyName: String!, $Comment: String!, $recaptcha: String) {
    sendRequest(firstName: $firstName, email: $username, companyName: $companyName, message: $Comment, recaptcha: $recaptcha) {
      success
      error
    }
  }
`;


// WEBPACK FOOTER //
// ./src/components/landing/gql/mutation.js